module.exports = __webpack_public_path__ + "img/new years shrine visit iii.dd01926f.png";